
document.addEventListener('DOMContentLoaded', function(event) {
    
	jQuery('.wp-block-crown-blocks-portal-links-grid-cell.hide-content').on('mouseenter', e => {
        const content = jQuery('.content', e.target);
        if ( ! content.length ) return;

        e.target.closest('.wp-block-crown-blocks-portal-links-grid-cell').classList.add('active');
        content.stop().slideDown();
    }).on('mouseleave', e => {
        const content = jQuery('.content', e.target);
        if ( ! content.length ) return;

        e.target.closest('.wp-block-crown-blocks-portal-links-grid-cell').classList.remove('active');
        content.stop().slideUp();
    });
	
});
